import OneStopPurchaseRequest from './OneStopPurchaseRequest';

export default OneStopPurchaseRequest;
